/**
 * WD-6 — Deactivate user.
 * US-A06 AC5: they can no longer log in, and a reason is recorded.
 */
import { useAdminTranslate } from '@/providers/i18n-provider'
import { ConfirmDialog } from './ConfirmDialog'

export interface DeactivateUserDialogProps {
  open: boolean
  userName: string
  reactivate?: boolean
  onConfirm: (reason: string) => Promise<void> | void
  onCancel: () => void
}

export const DeactivateUserDialog = ({
  open,
  userName,
  reactivate = false,
  onConfirm,
  onCancel,
}: DeactivateUserDialogProps) => {
  const translate = useAdminTranslate()
  const key = (name: 'title' | 'description' | 'confirm') => {
    const suffix = reactivate
      ? {
          title: 'reactivateTitle',
          description: 'reactivateDescription',
          confirm: 'reactivateConfirm',
        }[name]
      : name
    return `admin.dialogs.deactivate.${suffix}`
  }

  return (
    <ConfirmDialog
      open={open}
      danger={!reactivate}
      title={translate(key('title'), { name: userName })}
      description={translate(key('description'))}
      confirmLabel={translate(key('confirm'))}
      requireReason
      onConfirm={reason => onConfirm(reason ?? '')}
      onCancel={onCancel}
    />
  )
}
